import _slicedToArray from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState as r, useEffect as n } from "react";
import { PositionDetector as c } from "../utils/position-detector.js";

var b = function b(_ref) {
  var o = _ref.anchor,
      t = _ref.floatingElementId;

  var _r = r({
    top: 0,
    left: 0,
    visibility: "visible"
  }),
      _r2 = _slicedToArray(_r, 2),
      i = _r2[0],
      s = _r2[1];

  return n(function () {
    var e = new c(o, t);
    return e.observe(s), function () {
      e.unobserve();
    };
  }, [o, t]), i;
};

export { b as useAnchoredPosition };